import { render, staticRenderFns } from "./EntityDelete.vue?vue&type=template&id=41e58c25&lang=pug"
import script from "./EntityDelete.vue?vue&type=script&lang=js"
export * from "./EntityDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports